import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { ErrorBoundary } from '@web/utils';
import { ImageEditor, useBlockEdit } from '../../../';
export var BlockImageEditor = memo(function (_a) {
    var image = _a.image, height = _a.height;
    var onBlockChange = useBlockEdit().onBlockChange;
    var _b = useState(''), backgroundImage = _b[0], setBackgroundImage = _b[1];
    var refPhoto = useRef(null);
    useEffect(function () { return setBackgroundImage(image); }, [image]);
    var onDrop = useCallback(function (e) {
        var _a;
        var processGDriveImageURL = function (url) {
            var originalUrl = 'https://drive.google.com/file/d/';
            var correctURL = 'https://drive.google.com/thumbnail?id=';
            var correctURL2 = 'https://drive.google.com/uc?export=view&id=';
            if (url.substr(0, originalUrl.length) === originalUrl) {
                var arr = url.replace('https://drive.google.com/file/d/', '').split('/');
                return "" + correctURL2 + arr[0];
            }
            return url;
        };
        var newImage = processGDriveImageURL(((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) || e.target.value);
        onBlockChange({ backgroundImage: newImage });
        setBackgroundImage(newImage);
    }, []);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ImageEditor, { onChange: onDrop, innerRef: refPhoto, height: height, image: backgroundImage, noSlider: true, disableDrag: true })));
});
